import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CycloneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cyclone"}/>
}
